module.exports = __webpack_public_path__ + "static/media/h13_nie_bw.2d558d97.webp";